<template>
  <span></span>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'GetPrice',
  props: [
    'dateRange',
    'inventoryBlock',
    'guestCount',
  ],
  data() {
    return {
      ratePlanPrices: [],
      ratePriceRequestParameters: [],
    };
  },
  computed: {
    ...mapGetters(
      {
        rates: 'rates',
      },
    ),
    inventoryTypePrices() {
      const prices = {};
      this.ratePlanPrices.forEach((record) => {
        const price = {
          ratePlan: record.ratePlan,
          amount: record.amount,
        };
        if (prices[record.inventoryType]) {
          prices[record.inventoryType].push(price);
        } else {
          prices[record.inventoryType] = [price];
        }
      });
      return prices;
    },
    priceRange() {
      if (this.ratePlans) {
        const prices = [];
        this.ratePlans.forEach((ratePlan) => {
          prices.push(Number(ratePlan.amount));
        }, this);
        return [Math.min(...prices), Math.max(...prices)];
      }
      return [];
    },
  },
  methods: {
    updatePrice() {
      if (this.inventoryBlock && this.dateRange && this.guestCount && this.checkPreviousRequestParameters()) {
        this.saveRequestParameters();
        this.ratePlanPrices = [];
        axios.post('/api/rate-prices/',
          {
            date_from: this.dateRange.date_from,
            date_to: moment(this.dateRange.date_to).format('YYYY-MM-DD'),
            inventory_block: this.inventoryBlock,
            guests: this.guestCount,
          }).then((response) => {
          response.data.rate_plan_prices.forEach(function (ratePlan) {
            ratePlan.prices.forEach(function (prices) {
              this.ratePlanPrices.push({
                ratePlan: ratePlan.rate_plan,
                inventoryType: prices.inventory_type,
                amount: this.sumPrice(prices.prices),
              });
            }, this);
          }, this);
        });
      }
    },
    saveRequestParameters() {
      this.ratePriceRequestParameters = {
        inventoryBlock: this.inventoryBlock,
        dateRange: this.dateRange,
        guestCount: this.guestCount,
      };
    },
    checkPreviousRequestParameters() {
      return this.ratePriceRequestParameters.inventoryBlock !== this.inventoryBlock
          || this.ratePriceRequestParameters.dateRange !== this.dateRange
          || this.ratePriceRequestParameters.guestCount !== this.guestCount;
    },
    sumPrice(prices) {
      if (prices) {
        let total = 0;
        for (const item of prices) {
          if (item.price === null) {
            return null;
          }
          total += item.price;
        }
        return total;
      }
      return null;
    },
  },
  watch: {
    dateRange() {
      this.updatePrice();
    },
    inventoryBlock() {
      this.updatePrice();
    },
    guestCount() {
      this.updatePrice();
    },
    inventoryTypePrices: {
      // eslint-disable-next-line no-unused-vars
      handler(val, oldVal) {
        this.$emit('inventoryTypePricesChanged', this.inventoryTypePrices);
      },
      deep: true,
    },
  },
};
</script>
